import React, { useEffect, useState } from "react";
import styles from "./index.module.less";
import cx from "classnames";
import { DislikeFilled, DislikeOutlined, LikeFilled, MessageFilled, StarFilled } from "@ant-design/icons";
import { article, movie } from "@Api";
import { message } from "antd";
import Share from "@Components/movie/Details/Share";
import dayjs from "dayjs";
import { formatThousend } from "@Src/utils/helper";

const { fetchMovieLike, fetchMovieCollect } = movie;
const { fetchLike } = article;

const Headline = ({ data, messageIcon = true, id, model }) => {
  const [liked, setLiked] = useState(0);
  const [unLiked, setUnLiked] = useState(0);
  const [collect, setCollect] = useState(0);
  const [likeStatus, setLikedStatus] = useState("0");
  const [unLikeStatus, setUnLikedStatus] = useState("0");
  const [collectStatus, setCollectStatus] = useState("0");
  const [isLoading, setIsLoading] = useState(false);

  const handleClickLike = async (type) => {
    if (isLoading && model === "movie") {
      message.warning("請勿重複點擊！");
      return;
    }
    setIsLoading(true);
    try {
      await fetchLike({ action: type, id: id, model: model });

      const isLike = type === "like";
      const isUnlike = type === "unlike";
      if (isLike || type === "cancelLike") {
        setLikedStatus(isLike ? "1" : "0");
        setLiked(isLike ? Number(liked) + 1 : Number(liked) - 1);
      } else if (isUnlike || type === "cancelUnlike") {
        setUnLikedStatus(isUnlike ? "1" : "0");
        setUnLiked(isUnlike ? Number(unLiked) + 1 : Number(unLiked) - 1);
      }
      if (model !== "movie") {
        setIsLoading(false);
      }
    } catch (error) {}
  };

  const handleClickCollect = async () => {
    try {
      const isCollecting = collectStatus === "0";
      const newCollect = isCollecting ? Number(collect) + 1 : Number(collect) - 1;

      const res: any = await fetchMovieCollect({
        status: isCollecting ? "add" : "cancel",
        id: window.movie_id || 0,
        type: "5",
      });
      setCollectStatus(isCollecting ? "1" : "0");
      setCollect(newCollect);

      res.msg && message.success(res.msg);
    } catch (error) {}
  };

  const movieScroll = async () => {
    let comment: any = document.getElementById("Comment");
    let count = comment.offsetTop - 100 || 0;

    window.scrollTo(0, count);
  };

  useEffect(() => {
    const { like_status, unlike_status, likes, unlikes, fav_status, favorite_num } = data;

    if (like_status == "1" || unlike_status == "1") {
      setIsLoading(true);
    }

    setLikedStatus(like_status);
    setUnLikedStatus(unlike_status);
    setLiked(Number(likes || 0));
    setUnLiked(Number(unlikes || 0));
    setCollectStatus(fav_status);
    setCollect(Number(favorite_num || 0));
  }, [data]);

  return (
    <section className={styles["Headline"]}>
      <div className={styles["list"]}>
        <div className={styles["visits"]}>
          <span className='mr-24'>播放次數：{data.visits || formatThousend(data.views)}次</span>
          <span>{dayjs(data.publishedDate || data.publishedAt).format("YYYY-MM-DD")}</span>
        </div>
        <div className={styles["icon-item"]}>
          <div
            className={styles["tr"]}
            onClick={() => {
              if (likeStatus == "0") {
                handleClickLike("like");
              } else {
                handleClickLike("cancelLike");
              }
            }}
          >
            <LikeFilled
              style={{ color: likeStatus == "0" ? "#fff" : "#ff2100", fontSize: "20px", marginRight: "5px" }}
            />
            <span>{liked}</span>
          </div>
          {/* {model !== "movie" && (
            <div
              className={"text-16 cursor-pointer ml-20 flex items-center"}
              onClick={() => {
                if (unLikeStatus == "0") {
                  handleClickLike("unlike");
                } else {
                  handleClickLike("cancelUnlike");
                }
              }}
            >
              <DislikeFilled
                style={{ color: unLikeStatus == "0" ? "#fff" : "#3264FF", fontSize: "20px", marginRight: "5px" }}
              />
              <span>{unLiked}</span>
            </div>
          )} */}
          {data.fav_status && (
            <div className={styles["tr"]} onClick={handleClickCollect}>
              <StarFilled
                style={{ color: collectStatus == "0" ? "#fff" : "#fce024", fontSize: "20px", marginRight: "5px" }}
              />
              <span>{collect}</span>
            </div>
          )}
          {messageIcon && (
            <div
              id='comment_scroll'
              style={{ fontSize: "20px", marginRight: "5px" }}
              className='cursor-pointer'
              onClick={movieScroll}
            >
              <MessageFilled />
            </div>
          )}

          <div className={cx(styles["tr"], styles["show"])}>
            <div className={styles["share-item"]}>
              <Share data={data} status='2' />
            </div>
            <img src='https://photo.8891.com.tw/2023/04/27/1682566683440825.png' alt='' className='w-20 h-20' />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Headline;
